import alertIcon from "./assets/alert-circle.png";
import checkIcon from "./assets/check-circle.png";
import errorIcon from "./assets/error-circle.png";
import LiffButton from "./components/LiffButton";
import liffClient from "./services/liffClient";

type BindingResultType = "success" | "error" | "already-linked";

interface BindingResultProps {
  type: BindingResultType;
  message?: string | null;
  debugValue?: string | null;
}

const resultConfig = {
  success: {
    icon: checkIcon,
    title: "綁定成功",
    defaultMessage: "您的 LINE 帳號已完成綁定",
    buttonText: "返回 LINE",
  },
  error: {
    icon: errorIcon,
    title: "帳號綁定失敗",
    defaultMessage: "發生異常，請返回 LINE 後重新嘗試",
    buttonText: "返回",
  },
  "already-linked": {
    icon: alertIcon,
    title: "已完成綁定",
    defaultMessage: "此 LINE 帳號已完成綁定",
    buttonText: "返回 LINE",
  },
} satisfies Record<
  BindingResultType,
  {
    icon: string;
    title: string;
    defaultMessage: string;
    buttonText: string;
  }
>;

export default function BindingResult({
  type,
  message,
  debugValue,
}: BindingResultProps) {
  const config = resultConfig[type];

  return (
    <main className="flex flex-1 flex-col items-center justify-center px-4">
      <img src={config.icon} alt="" className="size-[105px]" />

      <div className="mt-7 text-center">
        <h1 className="text-[38px] font-bold leading-[48px]">{config.title}</h1>

        <p className="mt-1 text-nowrap text-[24px] font-light leading-[48px]">
          {message ?? config.defaultMessage}
        </p>
      </div>

      {debugValue && (
        <div className="my-8 w-full break-all bg-gray-100 p-4 text-[12px]">
          <strong>LINE ID Token:</strong>
          <br />
          {debugValue}
        </div>
      )}

      <LiffButton className="mt-8" onClick={liffClient.closeWindow}>
        {config.buttonText}
      </LiffButton>
    </main>
  );
}
